import { Scripts } from './scripts'

export const serverScripts = new Scripts()
